// status-ticket-row-answered-needs-decision.ts
//
// Phase 06j (F-50, R6): the `status` row of a ticket reads the journal's LAST
// verdict — for a `needs_decision` attempt that is "chờ người trả lời câu hỏi
// <q>" (needs-decision-attempt-reason.ts, one wording shared with the journal),
// and nothing ever rewrites it after `answer` or a redirect amend settles the
// question. This settles the line from interview.json at render time. Pure;
// `--json` `ticket_last_verdict` stays raw.
import { formatDecisionSource } from "./chat-delegated-attribution.js";
import type { Interview } from "./interview-store.js";
import type { TicketVerdictRecord } from "./mission-state-reducer.js";
import { awaitingAnswerQuestionId } from "./needs-decision-attempt-reason.js";
import { isNeedsDecisionQuestionOfTicket } from "./needs-decision-question-ticket-match.js";

export function settleAnsweredNeedsDecisionVerdict(
  ticketId: string,
  verdict: TicketVerdictRecord | undefined,
  interview: Interview | undefined,
): TicketVerdictRecord | undefined {
  if (verdict?.category !== "needs_decision" || interview === undefined) return verdict;
  const questionId =
    verdict.reasons.length === 1 ? awaitingAnswerQuestionId(verdict.reasons[0] ?? "") : undefined;
  if (questionId === undefined) return verdict;
  const stillOpen = interview.questions.some(
    (q) => isNeedsDecisionQuestionOfTicket(q, ticketId) && interview.answers[q.id] === undefined,
  );
  if (stillOpen) return verdict;
  const asked = interview.questions.some((q) => q.id === questionId);
  const answer = interview.answers[questionId];
  if (asked && answer === undefined) return verdict;
  const reason =
    answer !== undefined
      ? `đã chốt câu hỏi ${questionId} (nguồn ${formatDecisionSource(answer.answered_by)}) — chờ dispatch`
      : `câu hỏi ${questionId} không còn trong interview — chờ dispatch`;
  return { ...verdict, reasons: [reason] };
}
